(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports,
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 0);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    globals: true
  };
  exports.globals = void 0;

  var globals = _interopRequireWildcard(__webpack_require__(1));

  exports.globals = globals;

  var _Filter = __webpack_require__(2);

  Object.keys(_Filter).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _Filter[key];
      }
    });
  });

  var _IconButton = __webpack_require__(10);

  Object.keys(_IconButton).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _IconButton[key];
      }
    });
  });

  var _Label = __webpack_require__(11);

  Object.keys(_Label).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _Label[key];
      }
    });
  });

  var _Toggle = __webpack_require__(12);

  Object.keys(_Toggle).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _Toggle[key];
      }
    });
  });

  var _Toolbar = __webpack_require__(13);

  Object.keys(_Toolbar).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _Toolbar[key];
      }
    });
  });

  var _Tiles = __webpack_require__(15);

  Object.keys(_Tiles).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _Tiles[key];
      }
    });
  });

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }
  /***/

},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.DATE_FORMAT_FULL = exports.DATE_FORMAT = exports.COLOR_BACKGROUND = exports.COLOR_WARNING = exports.COLOR_POSITIVE = exports.COLOR_ALERT = exports.COLOR_CONTRAST = exports.COLOR_SECONDARY = exports.COLOR_PRIMARY = void 0;
  var COLOR_PRIMARY = '#61DAFB';
  exports.COLOR_PRIMARY = COLOR_PRIMARY;
  var COLOR_SECONDARY = '#222222';
  exports.COLOR_SECONDARY = COLOR_SECONDARY;
  var COLOR_CONTRAST = '#FFFFFF';
  exports.COLOR_CONTRAST = COLOR_CONTRAST;
  var COLOR_ALERT = '#ff695e';
  exports.COLOR_ALERT = COLOR_ALERT;
  var COLOR_POSITIVE = 'green';
  exports.COLOR_POSITIVE = COLOR_POSITIVE;
  var COLOR_WARNING = 'orange';
  exports.COLOR_WARNING = COLOR_WARNING;
  var COLOR_BACKGROUND = '#F6F6F6';
  exports.COLOR_BACKGROUND = COLOR_BACKGROUND;
  var DATE_FORMAT = 'dddd, DD. MMM YYYY';
  exports.DATE_FORMAT = DATE_FORMAT;
  var DATE_FORMAT_FULL = 'dddd, DD. MMM YYYY - HH:mm';
  exports.DATE_FORMAT_FULL = DATE_FORMAT_FULL;
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "ItemCountSelector", {
    enumerable: true,
    get: function get() {
      return _ItemCountSelector.default;
    }
  });
  Object.defineProperty(exports, "SearchFilter", {
    enumerable: true,
    get: function get() {
      return _SearchFilter.default;
    }
  });
  Object.defineProperty(exports, "Sortable", {
    enumerable: true,
    get: function get() {
      return _Sortable.default;
    }
  });

  var _ItemCountSelector = _interopRequireDefault(__webpack_require__(3));

  var _SearchFilter = _interopRequireDefault(__webpack_require__(8));

  var _Sortable = _interopRequireDefault(__webpack_require__(9));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /***/

},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var React = _interopRequireWildcard(__webpack_require__(4));

  var _propTypes = _interopRequireDefault(__webpack_require__(5));

  var _materialUi = __webpack_require__(6);

  var _semanticUiReact = __webpack_require__(7);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  var ItemCountSelector = function ItemCountSelector(_ref) {
    var icon = _ref.icon,
        options = _ref.options,
        selected = _ref.selected,
        style = _ref.style,
        optionStyle = _ref.optionStyle,
        optionProps = _ref.optionProps,
        _onChange = _ref.onChange,
        props = _objectWithoutProperties(_ref, ["icon", "options", "selected", "style", "optionStyle", "optionProps", "onChange"]);

    return React.createElement(_materialUi.SelectField, _extends({
      value: "".concat(selected),
      autoWidth: true,
      style: _objectSpread({
        width: 120
      }, style),
      underlineStyle: {
        display: 'none'
      },
      iconStyle: {
        display: 'none'
      },
      onChange: function onChange(_, key, value) {
        return _onChange(Number(value), key);
      }
    }, props), options.map(function (option) {
      return React.createElement(_materialUi.MenuItem, _extends({
        key: option,
        value: "".concat(option),
        style: optionStyle,
        primaryText: React.createElement("span", null, icon, " ", option)
      }, optionProps));
    }));
  };

  ItemCountSelector.propTypes = {
    icon: _propTypes.default.element,
    options: _propTypes.default.arrayOf(_propTypes.default.number.isRequired).isRequired,
    selected: _propTypes.default.number.isRequired,
    style: _propTypes.default.object,
    optionStyle: _propTypes.default.object,
    optionProps: _propTypes.default.object,
    onChange: _propTypes.default.func.isRequired
  };
  ItemCountSelector.defaultProps = {
    icon: React.createElement(_semanticUiReact.Icon, {
      name: 'list'
    }),
    style: {},
    optionStyle: {},
    optionProps: {}
  };
  var _default = ItemCountSelector;
  exports.default = _default;
  /***/
},
/* 4 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 5 */

/***/
function (module, exports) {
  module.exports = require("prop-types");
  /***/
},
/* 6 */

/***/
function (module, exports) {
  module.exports = require("material-ui");
  /***/
},
/* 7 */

/***/
function (module, exports) {
  module.exports = require("semantic-ui-react");
  /***/
},
/* 8 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var React = _interopRequireWildcard(__webpack_require__(4));

  var _propTypes = _interopRequireDefault(__webpack_require__(5));

  var _semanticUiReact = __webpack_require__(7);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  var SearchFilter = function SearchFilter(_ref) {
    var type = _ref.type,
        value = _ref.value,
        selected = _ref.selected,
        options = _ref.options,
        _onChange = _ref.onChange,
        onSelect = _ref.onSelect,
        labelPosition = _ref.labelPosition,
        placeholder = _ref.placeholder,
        style = _ref.style,
        props = _objectWithoutProperties(_ref, ["type", "value", "selected", "options", "onChange", "onSelect", "labelPosition", "placeholder", "style"]);

    return React.createElement(_semanticUiReact.Input, _extends({
      type: type,
      icon: React.createElement(_semanticUiReact.Icon, {
        style: value.trim() ? {
          pointerEvents: 'all'
        } : {
          display: 'none'
        },
        name: "remove",
        onClick: function onClick() {
          return _onChange('');
        }
      }),
      onChange: function onChange(_, data) {
        return _onChange(data.value);
      },
      value: value,
      label: React.createElement(_semanticUiReact.Dropdown, {
        onChange: function onChange(_, data) {
          return onSelect(data.value);
        },
        options: options,
        value: selected
      }),
      labelPosition: labelPosition,
      placeholder: placeholder,
      style: _objectSpread({
        marginRight: 30
      }, style)
    }, props));
  };

  SearchFilter.propTypes = {
    type: _propTypes.default.string,
    value: _propTypes.default.string,
    selected: _propTypes.default.string.isRequired,
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      key: _propTypes.default.string.isRequired,
      text: _propTypes.default.string.isRequired,
      value: _propTypes.default.string.isRequired
    })).isRequired,
    onChange: _propTypes.default.func.isRequired,
    onSelect: _propTypes.default.func.isRequired,
    labelPosition: _propTypes.default.oneOf(['left', 'right']),
    placeholder: _propTypes.default.string,
    style: _propTypes.default.object
  };
  SearchFilter.defaultProps = {
    type: 'search',
    value: '',
    options: [],
    labelPosition: 'left',
    placeholder: 'Suche...',
    style: {}
  };
  var _default = SearchFilter;
  exports.default = _default;
  /***/
},
/* 9 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var React = _interopRequireWildcard(__webpack_require__(4));

  var _propTypes = _interopRequireDefault(__webpack_require__(5));

  var _materialUi = __webpack_require__(6);

  var _semanticUiReact = __webpack_require__(7);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  var Sortable = function Sortable(_ref) {
    var autoWith = _ref.autoWith,
        onChange = _ref.onChange,
        value = _ref.value,
        options = _ref.options,
        props = _objectWithoutProperties(_ref, ["autoWith", "onChange", "value", "options"]);

    return React.createElement(_materialUi.SelectField, _extends({
      iconStyle: {
        display: 'none'
      },
      underlineStyle: {
        display: 'none'
      },
      autoWidth: autoWith,
      onChange: onChange,
      value: value
    }, props), options.map(function (_ref2) {
      var key = _ref2.key,
          title = _ref2.title,
          order = _ref2.order;
      return React.createElement(_materialUi.MenuItem, {
        key: key,
        value: key,
        primaryText: React.createElement("span", null, React.createElement(_semanticUiReact.Icon, {
          name: "sort content ".concat(order)
        }), title)
      });
    }));
  };

  Sortable.propTypes = {
    autoWidth: _propTypes.default.bool,
    onChange: _propTypes.default.func.isRequired,
    value: _propTypes.default.string.isRequired,
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      key: _propTypes.default.string.isRequired,
      order: _propTypes.default.oneOf(['ascending', 'descending']).isRequired,
      title: _propTypes.default.string.isRequired
    })).isRequired
  };
  Sortable.defaultProps = {
    autoWidth: true,
    options: []
  };
  var _default = Sortable;
  exports.default = _default;
  /***/
},
/* 10 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.asInkButton = exports.asIconButton = exports.InkButton = exports.IconButton = void 0;

  var React = _interopRequireWildcard(__webpack_require__(4));

  var _propTypes = _interopRequireDefault(__webpack_require__(5));

  var _materialUi = __webpack_require__(6);

  var _semanticUiReact = __webpack_require__(7);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }
  /**
   *
   * @param Component
   * @return IB
   * @private
   */


  var _refine = function _refine(Component) {
    var _class, _temp;

    return _temp = _class = /*#__PURE__*/function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              style = _this$props.style,
              tooltipPosition = _this$props.tooltipPosition,
              tooltipStyles = _this$props.tooltipStyles,
              popup = _this$props.popup,
              top = _this$props.top,
              right = _this$props.right,
              props = _objectWithoutProperties(_this$props, ["style", "tooltipPosition", "tooltipStyles", "popup", "top", "right"]);

          var myStyle = _objectSpread({
            padding: 0,
            fontSize: 'inherit'
          }, style);

          if (popup) {
            return React.createElement(_semanticUiReact.Popup, _extends({}, popup, {
              trigger: React.createElement(Component, _extends({
                style: myStyle
              }, props))
            }));
          }

          return React.createElement(Component, _extends({
            style: myStyle,
            tooltipPosition: tooltipPosition,
            tooltipStyles: _objectSpread({
              top: 20 + top,
              left: null,
              right: "calc(100% - 10px - ".concat(right, "px)")
            }, tooltipStyles)
          }, props));
        }
      }]);

      return _class;
    }(React.Component), _class.propTypes = {
      top: _propTypes.default.number,
      right: _propTypes.default.number,
      style: _propTypes.default.object,
      tooltipPosition: _propTypes.default.string,
      tooltipStyles: _propTypes.default.object,
      popup: _propTypes.default.object
    }, _class.defaultProps = {
      tooltipPosition: 'top-left',
      top: 0,
      right: 0
    }, _temp;
  };

  exports.asIconButton = _refine;

  var IconButton = _refine(_materialUi.IconButton);

  exports.IconButton = IconButton;

  var withMe = function withMe(Component) {
    return /*#__PURE__*/function (_React$Component2) {
      _inherits(_class3, _React$Component2);

      function _class3() {
        var _getPrototypeOf2;

        var _temp2, _this;

        _classCallCheck(this, _class3);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _possibleConstructorReturn(_this, (_temp2 = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_class3)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.render = function () {
          var _this$props2 = _this.props,
              style = _this$props2.style,
              children = _this$props2.children,
              tooltipPosition = _this$props2.tooltipPosition,
              ref = _this$props2.ref,
              props = _objectWithoutProperties(_this$props2, ["style", "children", "tooltipPosition", "ref"]);

          return React.createElement(Component, _extends({
            style: _objectSpread({
              padding: 0,
              fontSize: 'inherit'
            }, style),
            tooltipPosition: tooltipPosition,
            children: children
          }, props));
        }, _temp2));
      }

      return _class3;
    }(React.Component);
  };

  exports.asInkButton = withMe;
  var InkButton = withMe(_materialUi.IconButton);
  exports.InkButton = InkButton;
  /***/
},
/* 11 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.asFormLabel = void 0;

  var React = _interopRequireWildcard(__webpack_require__(4));

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  var asFormLabel = function asFormLabel(LabelComponent) {
    return /*#__PURE__*/function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              style = _this$props.style,
              props = _objectWithoutProperties(_this$props, ["style"]);

          return React.createElement(LabelComponent, _extends({
            style: _objectSpread({
              padding: '5px 8px',
              display: 'flex',
              alignItems: 'center'
            }, style)
          }, props));
        }
      }]);

      return _class;
    }(React.Component);
  };

  exports.asFormLabel = asFormLabel;
  /***/
},
/* 12 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Toggle = exports.asToggle = exports.togglify = void 0;

  var React = _interopRequireWildcard(__webpack_require__(4));

  var _propTypes = _interopRequireDefault(__webpack_require__(5));

  var _materialUi = __webpack_require__(6);

  var _Globals = __webpack_require__(1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  var _togglified = function _togglified(Component) {
    var _class, _temp;

    var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Globals.COLOR_PRIMARY;
    return _temp = _class = /*#__PURE__*/function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              thumbStyle = _this$props.thumbStyle,
              thumbSwitchStyle = _this$props.thumbSwitchStyle,
              props = _objectWithoutProperties(_this$props, ["thumbStyle", "thumbSwitchStyle"]);

          return React.createElement(Component, _extends({
            thumbStyle: _objectSpread({
              boxShadow: '0 0 0 1px #ddd'
            }, thumbStyle),
            thumbSwitchedStyle: _objectSpread({
              backgroundColor: color,
              boxShadow: '0 0 0 1px rgb(65, 170, 225)'
            }, thumbSwitchStyle)
          }, props));
        }
      }]);

      return _class;
    }(React.Component), _class.propTypes = _objectSpread({}, _materialUi.Toggle.propTypes, {
      thumbStyle: _propTypes.default.object,
      color: _propTypes.default.string
    }), _class.defaultProps = _objectSpread({}, _materialUi.Toggle.defaultProps, {
      color: 'blue'
    }), _temp;
  };

  var togglify = _togglified;
  exports.togglify = togglify;
  var asToggle = _togglified;
  exports.asToggle = asToggle;

  var Toggle = _togglified(_materialUi.Toggle);

  exports.Toggle = Toggle;
  /***/
},
/* 13 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Required = exports.PageHeader = exports.SubItem = exports.Title = exports.Subbar = void 0;

  var React = _interopRequireWildcard(__webpack_require__(4));

  var _propTypes = _interopRequireDefault(__webpack_require__(5));

  var _semanticUiReact = __webpack_require__(7);

  var _materialUi = __webpack_require__(6);

  var _classnames = _interopRequireDefault(__webpack_require__(14));

  var _Globals = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  var STYLE_ELLIPSIS = {
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  };

  var Subbar = function Subbar(_ref) {
    var children = _ref.children,
        align = _ref.align,
        valign = _ref.valign,
        style = _ref.style,
        direction = _ref.direction,
        props = _objectWithoutProperties(_ref, ["children", "align", "valign", "style", "direction"]);

    return React.createElement("div", _extends({
      style: _objectSpread({
        display: 'flex',
        alignItems: valign,
        justifyContent: align,
        flexDirection: direction
      }, style)
    }, props), children);
  };

  exports.Subbar = Subbar;
  Subbar.ALIGN_START = 'flex-start';
  Subbar.ALIGN_END = 'flex-end';
  Subbar.ALIGN_CENTER = 'center';
  Subbar.ALIGN_AROUND = 'space-around';
  Subbar.ALIGN_BETWEEN = 'space-between';
  Subbar.ALIGN_INITIAL = 'initial';
  Subbar.ALIGN_INHERIT = 'inherit';
  Subbar.VALIGN_START = 'flex-start';
  Subbar.VALIGN_END = 'flex-end';
  Subbar.VALIGN_CENTER = 'center';
  Subbar.VALIGN_STRETCH = 'stretch';
  Subbar.VALIGN_BASELINE = 'baseline';
  Subbar.VALIGN_INITIAL = 'initial';
  Subbar.VALIGN_INHERIT = 'inherit';
  Subbar.DIRECTION_ROW = 'row';
  Subbar.DIRECTION_ROW_REVERSE = 'row-reverse';
  Subbar.DIRECTION_COLUMN = 'column';
  Subbar.DIRECTION_COLUMN_REVERSE = 'column-reverse';
  Subbar.DIRECTION_INITIAL = 'initial';
  Subbar.DIRECTION_INHERIT = 'inherit';
  Subbar.INHERIT = 'inherit';
  Subbar.INITIAL = 'initial';
  Subbar.propTypes = {
    children: _propTypes.default.node,
    align: _propTypes.default.oneOf(['flex-start', 'flex-end', 'center', 'space-around', 'space-between', 'initial', 'inherit']),
    valign: _propTypes.default.oneOf(['flex-start', 'flex-end', 'center', 'stretch', 'baseline', 'initial', 'inherit']),
    style: _propTypes.default.object,
    direction: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse', 'initial', 'inherit'])
  };
  Subbar.defaultProps = {
    align: 'flex-start',
    valign: 'center',
    style: {},
    direction: Subbar.DIRECTION_ROW
  };

  var Title = function Title(_ref2) {
    var as = _ref2.as,
        children = _ref2.children,
        loading = _ref2.loading,
        style = _ref2.style,
        className = _ref2.className,
        props = _objectWithoutProperties(_ref2, ["as", "children", "loading", "style", "className"]);

    var Tag = as;
    return React.createElement(Tag, _extends({
      className: (0, _classnames.default)('ith-title', className),
      style: _objectSpread({
        margin: 0,
        padding: 0
      }, style)
    }, props), loading ? React.createElement(_semanticUiReact.Icon, {
      name: 'spinner',
      loading: loading
    }) : null, children);
  };

  exports.Title = Title;
  Title.propTypes = {
    className: _propTypes.default.string,
    as: _propTypes.default.string,
    style: _propTypes.default.object,
    children: _propTypes.default.node.isRequired,
    loading: _propTypes.default.bool
  };
  Title.defaultProps = {
    as: 'h2',
    style: {},
    loading: false
  };

  var SubItem = function SubItem(_ref3) {
    var children = _ref3.children,
        width = _ref3.width,
        style = _ref3.style,
        props = _objectWithoutProperties(_ref3, ["children", "width", "style"]);

    return React.createElement("span", _extends({
      style: _objectSpread({
        display: 'block',
        marginLeft: 8,
        marginRight: 8,
        width: width <= 1 ? width * 100 + '%' : width
      }, STYLE_ELLIPSIS, style)
    }, props), children);
  };

  exports.SubItem = SubItem;
  SubItem.propTypes = {
    children: _propTypes.default.node,
    width: _propTypes.default.number,
    style: _propTypes.default.object
  };
  SubItem.defaultProps = {
    width: 1,
    style: {}
  };

  var PageHeader = function PageHeader(_ref4) {
    var className = _ref4.className,
        children = _ref4.children,
        style = _ref4.style,
        dividerStyle = _ref4.dividerStyle,
        props = _objectWithoutProperties(_ref4, ["className", "children", "style", "dividerStyle"]);

    return React.createElement("div", {
      className: (0, _classnames.default)('ith-page-header', className),
      style: style
    }, React.createElement(Subbar, _extends({
      align: Subbar.ALIGN_BETWEEN
    }, props), children), React.createElement(_materialUi.Divider, {
      inset: true,
      style: _objectSpread({
        marginTop: 10,
        marginBottom: 10
      }, dividerStyle)
    }));
  };

  exports.PageHeader = PageHeader;
  PageHeader.propTypes = {
    children: _propTypes.default.node,
    dividerStyle: _propTypes.default.object,
    className: _propTypes.default.string,
    style: _propTypes.default.object
  };

  var Required = function Required(_ref5) {
    var children = _ref5.children,
        style = _ref5.style,
        _ref5$color = _ref5.color,
        color = _ref5$color === void 0 ? _Globals.default : _ref5$color;
    return React.createElement(React.Fragment, null, children, " ", React.createElement("span", {
      style: _objectSpread({
        color: color,
        fontWeight: 'bold'
      }, style)
    }, "*"));
  };

  exports.Required = Required;
  /***/
},
/* 14 */

/***/
function (module, exports) {
  module.exports = require("classnames");
  /***/
},
/* 15 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Tile = exports.Tiles = void 0;

  var React = _interopRequireWildcard(__webpack_require__(4));

  var _propTypes = _interopRequireDefault(__webpack_require__(5));

  var _classnames = _interopRequireDefault(__webpack_require__(14));

  var globals = _interopRequireWildcard(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  var Tiles = function Tiles(_ref) {
    var className = _ref.className,
        children = _ref.children,
        style = _ref.style,
        props = _objectWithoutProperties(_ref, ["className", "children", "style"]);

    return React.createElement("ul", _extends({
      className: (0, _classnames.default)('ith_tiles', className),
      style: _objectSpread({
        display: 'flex',
        flexWrap: 'wrap',
        listStyle: 'none',
        position: 'relative',
        padding: 0
      }, style)
    }, props), children);
  };

  exports.Tiles = Tiles;

  var Tile = /*#__PURE__*/function (_React$Component) {
    _inherits(Tile, _React$Component);

    function Tile() {
      var _getPrototypeOf2;

      var _temp, _this;

      _classCallCheck(this, Tile);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tile)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.style = {
        margin: 10,
        padding: 10,
        display: 'flex'
      }, _this.hoverStyle = {
        backgroundColor: globals.COLOR_PRIMARY || 'blue'
      }, _this.state = {
        style: _this.style
      }, _this.handleNormal = function () {
        var style = _objectSpread({}, _this.style, _this.props.style);

        _this.setState(function () {
          return {
            style: style
          };
        });
      }, _this.handleHover = function () {
        _this.setState(function () {
          return {
            style: _objectSpread({}, _this.style, _this.props.style, _this.hoverStyle, _this.props.hoverStyle)
          };
        });
      }, _temp));
    }

    _createClass(Tile, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.handleNormal();
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps() {
        this.handleNormal();
      }
    }, {
      key: "render",
      value: function render() {
        var style = this.state.style;

        var _this$props = this.props,
            children = _this$props.children,
            className = _this$props.className,
            width = _this$props.width,
            height = _this$props.height,
            square = _this$props.square,
            hoverStyle = _this$props.hoverStyle,
            omitStyle = _this$props.style,
            props = _objectWithoutProperties(_this$props, ["children", "className", "width", "height", "square", "hoverStyle", "style"]);

        if (square && (width || height)) {
          width = Math[square].call(null, width, height);
          height = Math[square].call(null, width, height);
        }

        return React.createElement("li", _extends({
          onMouseOut: this.handleNormal,
          onMouseOver: this.handleHover,
          className: (0, _classnames.default)('ith_tile', className),
          style: _objectSpread({
            width: width,
            height: height
          }, style)
        }, props), children);
      }
    }]);

    return Tile;
  }(React.Component);

  exports.Tile = Tile;
  Tile.propTypes = {
    children: _propTypes.default.node,
    className: _propTypes.default.string,
    width: _propTypes.default.number,
    height: _propTypes.default.number,
    square: _propTypes.default.string,
    style: _propTypes.default.object,
    hoverStyle: _propTypes.default.object
  };
  Tile.defaultProps = {
    style: {},
    hoverStyle: {}
  };
  /***/
}
/******/
]));